export const MYCLIENTSALES_TAB_FULL_ROUTE = 'clientsales/view/:id/:cbTabRouteId';
